import styled from 'styled-components';
import { Typography } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const Header = styled(PageHeader)`
  margin-bottom: 16px;
  padding: 0;

  & .ant-page-header-back {
    font-size: 22px;
  }

  & .ant-page-header-heading-left,
  & .ant-page-header-heading-right {
    margin: 0;
  }
`;

export const Title = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom: 0;
  }
`;

export const SubHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: -16px;
  margin-bottom: 16px;
  padding-left: 38px;
  color: ${colors.gray650};

  & > * {
    margin-right: 16px;
  }
`;
